import { CSSProperties, ReactElement } from "react";
interface IProps {
  title: string;
  subTitle?: string;
  children: ReactElement;
  ratio?: number;
}

const rowStyle = (ratio?: number): CSSProperties => ({
  display: "grid",
  gap: ".5em",
  gridTemplateColumns: ratio ? `${ratio * 100}% ${100 - ratio * 100}%` : "40% 60%",
  gridTemplateRows: "1fr",
  justifyContent: "stretch",
  alignContent: "stretch"
});


const titleCellStyle = (): CSSProperties => ({
  padding: ".5em",
  alignSelf: "stretch",
  gridColumn: "1 / span 1",
  borderRadius: 5,
  background: "rgba(50, 50, 50, .3)"
});

const valueCellStyle = (): CSSProperties => ({
  display: "grid",
  gridColumn: "2 / span 1",
  alignContent: "center",
  justifyContent: "stretch"
  // borderRadius: 5,
  // background: "rgba(150, 150, 150, .3)",
  // overflow: "hidden"
});


const RowComponent = ({ title, subTitle, children, ratio }: IProps) => {

  return (
    <div style={rowStyle(ratio)}>
      <div style={titleCellStyle()} className="display-grid" >
        <div className="align-self-center display-flex-column">
          <strong>{title}</strong>
          {subTitle && <small>{subTitle}</small>}
        </div>
      </div>
      <div style={valueCellStyle()}>
        {children}
      </div>
    </div>
  );
};

export default RowComponent;